import React from 'react';
import { Typography, Card, Box, Paper } from '@mui/material';
import { styled } from '@mui/system';
import { makeStyles } from "tss-react/mui";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useStudy } from '../../../pages/study/hooks';
import Button from '../../Button';

const useStyles = makeStyles()((theme) => ({
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        zIndex: 10,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
}));

const StyledPaper = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
    maxWidth: 500,
    width: '100%',
    borderRadius: '20px',
    overflow: 'hidden',
    position: 'relative',
}));

const CoursePausedOverlay = () => {
    const { classes } = useStyles();
    const { paused, setPaused } = useStudy();

    const onResumeClick = () => {
        setPaused(false);
    };

    if (!paused) return null;

    return (
        <div className={classes.overlay}>
            <StyledPaper elevation={2}>
                <Typography variant="h4" component="h2" gutterBottom sx={{ fontWeight: 'bold', textAlign: 'center', textShadow: '2px 2px 4px rgba(0,0,0,0.1)' }}>
                    Time for a Break!
                </Typography>
                <Box sx={{ width: '100%', height: '150px', position: 'relative', marginBottom: 2 }}>
                    <svg width="100%" height="100%" viewBox="0 0 200 150" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="100" cy="75" r="60" fill="#FFD700" />
                        <path d="M100 25C89.3958 25 79.0208 27.9167 70.3125 33.3333C61.6042 38.75 54.6875 46.4583 50.5208 55.8333C46.3542 65.2083 45.1042 75.7292 46.9792 85.9375C48.8542 96.1458 53.75 105.521 61.0417 112.812C68.3333 120.104 77.7083 125 87.9167 126.875C98.125 128.75 108.646 127.5 118.021 123.333C127.396 119.167 135.104 112.25 140.521 103.542C145.937 94.8333 148.854 84.4583 148.854 73.8542" stroke="#FFA500" strokeWidth="8" strokeLinecap="round" />
                        <path d="M100 45V75L120 95" stroke="#FFA500" strokeWidth="8" strokeLinecap="round" />
                    </svg>
                </Box>
                <Typography variant="body1" sx={{ textAlign: 'center', maxWidth: '80%', marginBottom: 2 }}>
                    Your course is paused due to inactivity. Take a moment to relax, then dive back in when you're ready!
                </Typography>
                <Button placeholder={
                    <>
                        <span>Resume Learning</span><PlayArrowIcon />
                    </>
                } variant="contained" size="large" onClick={onResumeClick} />
            </StyledPaper>
        </div>
    );
};

export default CoursePausedOverlay;